export default __webpack_public_path__ + "static/media/gallery7.cce5341d.JPG";